import { render, staticRenderFns } from "./productItem1.vue?vue&type=template&id=4c85e822&scoped=true&"
import script from "./productItem1.vue?vue&type=script&lang=js&"
export * from "./productItem1.vue?vue&type=script&lang=js&"
import style0 from "./productItem1.vue?vue&type=style&index=0&id=4c85e822&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85e822",
  null
  
)

export default component.exports